<template><div class="loading"></div></template>

<script>
export default {

}
</script>


<style scoped>
.loading {
  position: relative;
  width: 2.5em;
  height: 2.5em;
  transform: rotate(165deg);
}

.loading:before,
.loading:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 0.5em;
  height: 0.5em;
  border-radius: 0.25em;
  transform: translate(-50%, -50%);
}

.loading:before {
  animation: before 2s infinite;
}

.loading:after {
  animation: after 2s infinite;
}

@keyframes before {
  0% {
    width: 0.5em;
    box-shadow: 1em -0.5em rgba(217, 252, 255, 0.75), -1em 0.5em rgba(103, 241, 254, 0.75);
  }

  35% {
    width: 2.5em;
    box-shadow: 0 -0.5em rgba(217, 252, 255, 0.75), 0 0.5em rgba(103, 241, 254, 0.75);
  }

  70% {
    width: 0.5em;
    box-shadow: -1em -0.5em rgba(217, 252, 255, 0.75), 1em 0.5em rgba(103, 241, 254, 0.75);
  }

  100% {
    box-shadow: 1em -0.5em rgba(217, 252, 255, 0.75), -1em 0.5em rgba(103, 241, 254, 0.75);
  }
}

@keyframes after {
  0% {
    height: 0.5em;
    box-shadow: 0.5em 1em rgba(161, 247, 255, 0.75), -0.5em -1em rgba(40, 216, 232, 0.75);
  }

  35% {
    height: 2.5em;
    box-shadow: 0.5em 0 rgba(161, 247, 255, 0.75), -0.5em 0 rgba(40, 216, 232, 0.75);
  }

  70% {
    height: 0.5em;
    box-shadow: 0.5em -1em rgba(161, 247, 255, 0.75), -0.5em 1em rgba(40, 216, 232, 0.75);
  }

  100% {
    box-shadow: 0.5em 1em rgba(161, 247, 255, 0.75), -0.5em -1em rgba(40, 216, 232, 0.75);
  }
}

html,
body {
  height: 100%;
}

.loading {
  position: absolute;
  top: calc(50% - 1.25em);
  left: calc(50% - 1.25em);
}

</style>
